export const updateProductField = (field, value) => ({
  type: 'UPDATE_PRODUCT_FIELD',
  field,
  value,
})
